export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  heat: string;
  views: string;
  timeAgo: string;
  image: string;
  imageThumb: string;
  isTop: boolean;
  isVerified: boolean;
  tags: string[];
}

export const categories = [
  { name: '今日大瓜', slug: 'today-hot', icon: 'ri-fire-line', description: '今日最劲爆的大瓜都在这里，实时追踪全网热议话题，让你不错过每一个热点事件。从娱乐圈到网红圈，从社会新闻到行业黑幕，吃瓜群众的第一手信息来源。' },
  { name: '网红黑料', slug: 'influencer-scandal', icon: 'ri-user-search-line', description: '深度揭秘网红圈内幕，曝光虚假人设、假货带货、偷税漏税等网红黑料。还原真实面貌，揭露光鲜背后的真相。' },
  { name: '明星塌房', slug: 'celebrity-downfall', icon: 'ri-home-smile-2-line', description: '明星塌房事件全程追踪，从偶像失格到违法乱纪，从恋情曝光到翻车实录。第一时间掌握娱乐圈最新风暴动态。' },
  { name: '实时爆料', slug: 'realtime-expose', icon: 'ri-flashlight-line', description: '24小时不间断实时爆料，匿名投稿与编辑追踪双渠道，确保每一个爆料都第一时间送达吃瓜前线。' },
  { name: '娱乐圈', slug: 'entertainment', icon: 'ri-movie-2-line', description: '娱乐圈大小事一网打尽，电影、综艺、音乐、选秀全领域覆盖，深度解析娱乐工业背后的利益链条与权力游戏。' },
  { name: '吃瓜合集', slug: 'gossip-collection', icon: 'ri-chat-smile-2-line', description: '经典吃瓜回顾与话题盘点，把散落的瓜串成完整的故事线。从时间线梳理到多方视角对比，让你的吃瓜体验更完整。' },
];

export const hotArticles: Article[] = [
  {
    id: '1',
    slug: 'top-streamer-tax-evasion-2026',
    title: '某顶流主播涉嫌偷税漏税2.3亿，已被税务部门依法调查取证',
    excerpt: '据知情人士透露，该主播近三年通过多个壳公司转移收入，目前案件已进入司法程序，或面临巨额罚款及刑事责任。',
    category: '网红黑料',
    categorySlug: 'influencer-scandal',
    heat: '986.5w',
    views: '156.2w',
    timeAgo: '2小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20newsroom%20scene%20with%20warm%20spotlight%20and%20deep%20shadows%2C%20mysterious%20atmosphere%2C%20breaking%20news%20editorial%20style%2C%20no%20people%20visible%2C%20abstract%20composition&width=600&height=450&seq=hot-01-tax-evasion&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20newsroom%20scene%20with%20warm%20spotlight%20and%20deep%20shadows%2C%20compact%20abstract%20composition%2C%20editorial&width=200&height=140&seq=hot-01-tax-evasion-thumb&orientation=landscape',
    isTop: true,
    isVerified: true,
    tags: ['偷税漏税', '顶流主播', '税务调查'],
  },
  {
    id: '2',
    slug: 'idol-group-internal-bullying',
    title: '某偶像团体内部霸凌录音曝光，经纪公司紧急发声明否认',
    excerpt: '一段长达23分钟的录音在社交平台疯传，涉及某当红男团内部成员之间的激烈争吵与人身攻击，粉丝群体已炸锅。',
    category: '明星塌房',
    categorySlug: 'celebrity-downfall',
    heat: '872.3w',
    views: '134.6w',
    timeAgo: '5小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20stage%20backdrop%20with%20dramatic%20red%20and%20black%20lighting%2C%20empty%20performance%20stage%2C%20tense%20atmosphere%2C%20editorial%20photography%20style&width=600&height=450&seq=hot-02-idol-bullying&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20stage%20with%20red%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20compact%20editorial%20composition&width=200&height=140&seq=hot-02-idol-bullying-thumb&orientation=landscape',
    isTop: true,
    isVerified: true,
    tags: ['偶像团体', '霸凌', '录音曝光'],
  },
  {
    id: '3',
    slug: 'beauty-blogger-fake-products',
    title: '百万粉丝美妆博主被曝卖假货，成本30卖980，受害者集体维权',
    excerpt: '多名消费者提供检测报告证实该博主推荐的"自主研发"产品成分与宣传严重不符，已有多地市场监管部门介入。',
    category: '网红黑料',
    categorySlug: 'influencer-scandal',
    heat: '765.8w',
    views: '112.3w',
    timeAgo: '8小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20cosmetics%20display%20with%20dramatic%20shadow%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20product%20photography%20with%20deep%20contrast&width=600&height=450&seq=hot-03-fake-beauty&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20cosmetics%20with%20dramatic%20shadows%2C%20compact%20editorial%20composition&width=200&height=140&seq=hot-03-fake-beauty-thumb&orientation=landscape',
    isTop: true,
    isVerified: true,
    tags: ['美妆博主', '假货', '消费者维权'],
  },
  {
    id: '4',
    slug: 'a-list-actress-affair-scandal',
    title: '一线女星被拍到深夜与已婚导演幽会，六小时未出酒店引发全网热议',
    excerpt: '狗仔队蹲守多日终于拍到实锤画面，视频中清晰可见两人前后进入同一酒店房间，男方妻子已取关该女星所有社交账号。',
    category: '明星塌房',
    categorySlug: 'celebrity-downfall',
    heat: '721.4w',
    views: '108.9w',
    timeAgo: '12小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20luxury%20hotel%20corridor%20at%20night%20with%20dramatic%20lighting%20and%20deep%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20no%20people&width=600&height=450&seq=hot-04-hotel-scandal&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20hotel%20corridor%20night%2C%20dramatic%20cinematic%20lighting%2C%20compact%20composition&width=200&height=140&seq=hot-04-hotel-scandal-thumb&orientation=landscape',
    isTop: false,
    isVerified: true,
    tags: ['一线女星', '婚外情', '酒店幽会'],
  },
  {
    id: '5',
    slug: 'live-streamer-charity-fraud',
    title: '某平台千万粉主播"慈善带货"翻车，善款去向成谜被质疑诈骗',
    excerpt: '该主播声称直播收益全部捐给贫困山区，但网友发现其公布的捐赠凭证存在多处PS痕迹，相关慈善机构否认收到捐款。',
    category: '网红黑料',
    categorySlug: 'influencer-scandal',
    heat: '689.2w',
    views: '98.3w',
    timeAgo: '16小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20with%20shattered%20glass%20effect%20and%20warm%20golden%20light%2C%20abstract%20composition%2C%20editorial%20breaking%20news%20style%2C%20deep%20contrast&width=600&height=450&seq=hot-05-charity-fraud&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20shattered%20glass%20with%20warm%20light%2C%20abstract%20editorial%20compact%20composition&width=200&height=140&seq=hot-05-charity-fraud-thumb&orientation=landscape',
    isTop: false,
    isVerified: false,
    tags: ['慈善带货', '诈骗', '善款去向'],
  },
  {
    id: '6',
    slug: 'boy-band-member-secret-marriage',
    title: '顶流男团成员被曝隐婚三年，妻子为圈外人，粉丝后援会集体脱粉',
    excerpt: '网友扒出该成员的结婚登记记录及其配偶的社交媒体账号，大量恋爱细节被曝光，经纪公司至今未做出正式回应。',
    category: '明星塌房',
    categorySlug: 'celebrity-downfall',
    heat: '654.7w',
    views: '89.2w',
    timeAgo: '20小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20romantic%20wedding%20ring%20on%20black%20velvet%20with%20dramatic%20spotlight%2C%20mysterious%20elegant%20atmosphere%2C%20editorial%20jewelry%20photography&width=600&height=450&seq=hot-06-secret-marriage&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20wedding%20ring%20black%20velvet%2C%20dramatic%20compact%20composition&width=200&height=140&seq=hot-06-secret-marriage-thumb&orientation=landscape',
    isTop: false,
    isVerified: true,
    tags: ['顶流男团', '隐婚', '脱粉'],
  },
  {
    id: '7',
    slug: 'competition-show-rigged-voting',
    title: '某选秀节目被曝投票造假，内部员工爆料：出道位早已内定',
    excerpt: '一名自称节目组前员工在匿名平台发布大量聊天记录和内部文件截图，详细披露了投票数据被篡改的全过程。',
    category: '娱乐圈',
    categorySlug: 'entertainment',
    heat: '612.1w',
    views: '85.7w',
    timeAgo: '1天前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20spotlight%20with%20empty%20audience%20seats%2C%20mysterious%20competition%20set%2C%20editorial%20cinematic%20style%2C%20deep%20shadows&width=600&height=450&seq=hot-07-rigged-voting&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20stage%20spotlight%20empty%20seats%2C%20cinematic%20compact%20composition&width=200&height=140&seq=hot-07-rigged-voting-thumb&orientation=landscape',
    isTop: false,
    isVerified: false,
    tags: ['选秀节目', '投票造假', '内定'],
  },
  {
    id: '8',
    slug: 'famous-singer-drug-scandal',
    title: '知名歌手涉毒被警方带走，现场搜出多种违禁品，工作室火速解约',
    excerpt: '据北京警方通报，在某高档公寓内抓获一名涉嫌吸毒的男性艺人，经网友比对照片确认为某知名音乐人，其工作室已删除所有相关内容并宣布解约。',
    category: '明星塌房',
    categorySlug: 'celebrity-downfall',
    heat: '587.3w',
    views: '79.5w',
    timeAgo: '1天前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20ominous%20police%20tape%20and%20flashing%20red%20blue%20lights%20in%20night%2C%20urban%20scene%2C%20dramatic%20editorial%20photography%2C%20deep%20shadows&width=600&height=450&seq=hot-08-drug-scandal&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20police%20tape%20night%20flashing%20lights%2C%20dramatic%20compact%20composition&width=200&height=140&seq=hot-08-drug-scandal-thumb&orientation=landscape',
    isTop: false,
    isVerified: true,
    tags: ['涉毒', '警方通报', '解约'],
  },
  {
    id: '9',
    slug: 'food-blogger-hygiene-scandal',
    title: '美食探店博主后厨实拍发现老鼠蟑螂，店铺连夜关门已立案调查',
    excerpt: '该博主在某网红火锅店直播探访时意外拍到后厨老鼠横行画面，目前市场监管部门已对该店铺进行查封并立案调查。',
    category: '实时爆料',
    categorySlug: 'realtime-expose',
    heat: '543.6w',
    views: '71.3w',
    timeAgo: '2天前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20grimy%20kitchen%20scene%20with%20eerie%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20documentary%20style%2C%20deep%20shadows%20and%20warm%20tones&width=600&height=450&seq=hot-09-hygiene-scandal&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20grimy%20kitchen%20eerie%20lighting%2C%20documentary%20compact%20composition&width=200&height=140&seq=hot-09-hygiene-scandal-thumb&orientation=landscape',
    isTop: false,
    isVerified: true,
    tags: ['美食探店', '卫生问题', '立案调查'],
  },
  {
    id: '10',
    slug: 'ceo-domestic-violence-expose',
    title: '某知名互联网公司CEO被前妻实名举报家暴，公司股价应声暴跌15%',
    excerpt: '前妻在社交平台发布长文并附带医院验伤报告和多段家暴视频证据，引发舆论哗然。公司紧急召开董事会，该CEO已主动辞职。',
    category: '今日大瓜',
    categorySlug: 'today-hot',
    heat: '528.9w',
    views: '68.4w',
    timeAgo: '2天前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20ominous%20corporate%20boardroom%20with%20shattered%20documents%20and%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20editorial%20business%20photography%2C%20deep%20shadows&width=600&height=450&seq=hot-10-ceo-violence&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20boardroom%20shattered%20documents%2C%20dramatic%20compact%20composition&width=200&height=140&seq=hot-10-ceo-violence-thumb&orientation=landscape',
    isTop: false,
    isVerified: true,
    tags: ['家暴', 'CEO', '实名举报'],
  },
  {
    id: '11',
    slug: 'variety-show-contract-dispute',
    title: '综艺常驻嘉宾怒撕节目组合同，曝光天价片酬内幕：一集报价800万',
    excerpt: '该嘉宾因节目组恶意剪辑损害其形象而公开合同细节，其中显示其一季（12期）固定片酬高达9600万，引发社会对明星薪酬的广泛争议。',
    category: '娱乐圈',
    categorySlug: 'entertainment',
    heat: '496.2w',
    views: '62.1w',
    timeAgo: '2天前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20torn%20contract%20papers%20on%20mahogany%20desk%20with%20dramatic%20side%20lighting%2C%20mysterious%20elegant%20atmosphere%2C%20editorial%20style&width=600&height=450&seq=hot-11-contract-fight&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20torn%20contract%20papers%20mahogany%20desk%2C%20dramatic%20compact%20composition&width=200&height=140&seq=hot-11-contract-fight-thumb&orientation=landscape',
    isTop: false,
    isVerified: true,
    tags: ['综艺', '天价片酬', '合同纠纷'],
  },
  {
    id: '12',
    slug: 'esports-star-match-fixing',
    title: '电竞圈大地震：某冠军选手涉嫌打假赛，LPL官方已启动调查程序',
    excerpt: '匿名举报人提供了该选手与外围赌博庄家的聊天记录和银行转账截图，涉及金额超过500万元，若查实将面临终身禁赛。',
    category: '实时爆料',
    categorySlug: 'realtime-expose',
    heat: '471.5w',
    views: '58.7w',
    timeAgo: '3天前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20gaming%20arena%20with%20dramatic%20purple%20and%20red%20neon%20lighting%2C%20empty%20esports%20stage%2C%20mysterious%20atmosphere%2C%20editorial%20cinematic&width=600&height=450&seq=hot-12-esports-scandal&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20gaming%20arena%20neon%20lights%2C%20esports%20stage%2C%20cinematic%20compact%20composition&width=200&height=140&seq=hot-12-esports-scandal-thumb&orientation=landscape',
    isTop: false,
    isVerified: false,
    tags: ['电竞', '假赛', '外围赌博'],
  },
];

export const featuredArticles: Article[] = [
  {
    id: 'f1',
    slug: 'top-streamer-tax-evasion-2026',
    title: '某顶流主播涉嫌偷税漏税2.3亿',
    excerpt: '近三年通过多个壳公司转移收入，案件已进入司法程序。',
    category: '网红黑料',
    categorySlug: 'influencer-scandal',
    heat: '986.5w',
    views: '156.2w',
    timeAgo: '2小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20breaking%20news%20concept%20with%20warm%20red%20spotlight%2C%20mysterious%20editorial%20photography%2C%20deep%20shadows%20and%20cinematic%20mood&width=600&height=450&seq=feat-01-tax-evasion&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20breaking%20news%20red%20spotlight%2C%20compact%20cinematic%20composition&width=200&height=140&seq=feat-01-tax-evasion-thumb&orientation=landscape',
    isTop: true,
    isVerified: true,
    tags: ['偷税漏税', '顶流主播'],
  },
  {
    id: 'f2',
    slug: 'idol-group-internal-bullying',
    title: '某偶像团体内部霸凌录音曝光',
    excerpt: '23分钟录音涉及激烈争吵与人身攻击，粉丝已炸锅。',
    category: '明星塌房',
    categorySlug: 'celebrity-downfall',
    heat: '872.3w',
    views: '134.6w',
    timeAgo: '5小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20concert%20stage%20with%20dramatic%20crimson%20lighting%2C%20empty%20seats%2C%20tense%20editorial%20photography%2C%20deep%20contrast&width=600&height=450&seq=feat-02-idol-bullying&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20concert%20stage%20crimson%20lighting%2C%20tense%20compact%20composition&width=200&height=140&seq=feat-02-idol-bullying-thumb&orientation=landscape',
    isTop: false,
    isVerified: true,
    tags: ['偶像团体', '霸凌'],
  },
  {
    id: 'f3',
    slug: 'a-list-actress-affair-scandal',
    title: '一线女星深夜与已婚导演幽会',
    excerpt: '狗仔队实锤画面：两人前后进入酒店房间六小时未出。',
    category: '明星塌房',
    categorySlug: 'celebrity-downfall',
    heat: '721.4w',
    views: '108.9w',
    timeAgo: '12小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20hotel%20room%20doorway%20at%20night%20with%20dramatic%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20style%2C%20deep%20shadows&width=600&height=450&seq=feat-03-hotel-affair&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20hotel%20door%20night%2C%20cinematic%20compact%20composition&width=200&height=140&seq=feat-03-hotel-affair-thumb&orientation=landscape',
    isTop: false,
    isVerified: true,
    tags: ['一线女星', '婚外情'],
  },
  {
    id: 'f4',
    slug: 'beauty-blogger-fake-products',
    title: '百万粉美妆博主卖假货被维权',
    excerpt: '成本30卖980，多地市场监管部门已介入调查。',
    category: '网红黑料',
    categorySlug: 'influencer-scandal',
    heat: '765.8w',
    views: '112.3w',
    timeAgo: '8小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20makeup%20palette%20with%20dramatic%20shadow%20lighting%2C%20luxury%20cosmetics%2C%20mysterious%20editorial%20composition%2C%20deep%20contrast&width=600&height=450&seq=feat-04-fake-beauty&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20makeup%20dramatic%20shadows%2C%20luxury%20compact%20composition&width=200&height=140&seq=feat-04-fake-beauty-thumb&orientation=landscape',
    isTop: false,
    isVerified: true,
    tags: ['美妆博主', '假货'],
  },
  {
    id: 'f5',
    slug: 'ceo-domestic-violence-expose',
    title: '互联网CEO被前妻举报家暴',
    excerpt: '附带验伤报告和家暴视频，公司股价暴跌15%。',
    category: '今日大瓜',
    categorySlug: 'today-hot',
    heat: '528.9w',
    views: '68.4w',
    timeAgo: '2天前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20ominous%20office%20with%20scattered%20papers%20and%20dramatic%20window%20light%2C%20tense%20corporate%20editorial%20photography%2C%20deep%20shadows&width=600&height=450&seq=feat-05-ceo-violence&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20ominous%20office%20scattered%20papers%2C%20tense%20compact%20composition&width=200&height=140&seq=feat-05-ceo-violence-thumb&orientation=landscape',
    isTop: false,
    isVerified: true,
    tags: ['家暴', 'CEO'],
  },
  {
    id: 'f6',
    slug: 'esports-star-match-fixing',
    title: '冠军电竞选手涉嫌打假赛',
    excerpt: '聊天记录与转账截图曝光，涉额超500万。',
    category: '实时爆料',
    categorySlug: 'realtime-expose',
    heat: '471.5w',
    views: '58.7w',
    timeAgo: '3天前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20esports%20arena%20with%20dramatic%20neon%20red%20and%20blue%20lighting%2C%20empty%20gaming%20chairs%2C%20mysterious%20editorial%20style&width=600&height=450&seq=feat-06-esports-fake&orientation=landscape',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20esports%20arena%20neon%20lights%2C%20empty%20gaming%20compact%20composition&width=200&height=140&seq=feat-06-esports-fake-thumb&orientation=landscape',
    isTop: false,
    isVerified: false,
    tags: ['电竞', '假赛'],
  },
];